import React from "react";

export const MyAELogo = ({ size = 34, showWordmark = true, onDark = false, className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="myae-logo">
    <div
      className="rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-700 flex items-center justify-center text-white font-display font-semibold shadow-[0_4px_12px_rgba(79,70,229,0.35)] shrink-0"
      style={{ width: size, height: size, fontSize: size * 0.46 }}
    >
      Æ
    </div>
    {showWordmark && (
      <span
        className={`font-display font-semibold tracking-tight leading-none ${onDark ? "text-white" : "text-zinc-900"}`}
        style={{ fontSize: size * 0.56 }}
      >
        My<span className="text-indigo-500">AE</span>
      </span>
    )}
  </div>
);
